import { effectiveDPI } from "./units";

export const DPI_TARGET = 300;
export const DPI_WARNING_THRESHOLD = 220;

export function dpiStatus(imgPxW, imgPxH, frameWmm, frameHmm) {
  const dpi = effectiveDPI(imgPxW, imgPxH, frameWmm, frameHmm);
  let level = "ok";
  if (dpi < DPI_WARNING_THRESHOLD) level = "warn";
  if (dpi < 150) level = "danger";
  return { dpi, level };
}
